import { ChatEmojiService } from '@agent/agent-interface/contact-view/chat/services/chat-emoji.service';
import { ChatMessageUtilService } from '@agent/agent-interface/contact-view/chat/services/chat-message-util.service';
import { Component, Input, OnInit } from '@angular/core';
import { ChatCopyGuest } from '@commons/chat-assistance/models/chat-copy-guest';
import { IChatMessage } from '@commons/chat-assistance/models/chat-message';

import { ProfileFacade, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-copy-list',
  templateUrl: 'chat-copy-list.component.html',
  styleUrls: ['./chat-copy-list.component.scss'],
})
export class ChatCopyListComponent implements OnInit {
  @Input()
  copyMessages: IChatMessage[];

  customerName: string = '';
  csrName: string = '';
  expanded: boolean = false;

  constructor(
    private readonly chatEmojiService: ChatEmojiService,
    private readonly chatMessageUtilService: ChatMessageUtilService,
    private readonly profileFacade: ProfileFacade
  ) {}

  ngOnInit(): void {
    this.profileFacade.profile$.pipe(untilDestroyed(this)).subscribe(profile => (this.csrName = profile.firstname));
    if (this.copyMessages) {
      const message = this.copyMessages.find(m => m.copyGuest.isCustomer);
      if (message) {
        this.customerName = message.copyGuest.firstName;
      }
    }
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  isFromUnknownContact(message: IChatMessage) {
    return message.copyGuest && ChatCopyGuest.isFromUnknownContact(message.copyGuest);
  }

  getMessageContent(message: string): string {
    let text = this.chatMessageUtilService.processContent(message);
    return this.chatEmojiService.emojify(text);
  }
}
